/**
 * assets/partner-profile.js
 * Gedrag van sections/partner-profile.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

  /* Partner- en klantcontext uit het JSON-eiland #pp-config hierboven.
     Zie ARCHITECTURE.md sectie 11. */
  var PP = { partner: { name: '', type: '', city: '', email: '', wa: '', tel: '' },
             klant: { ingelogd: false, email: '', naam: '', voornaam: '' } };
  try {
    var _ppEl = document.getElementById('pp-config');
    if (_ppEl) PP = Object.assign(PP, JSON.parse(_ppEl.textContent) || {});
  } catch (_e) {}

(function(){
  var ppData = {
    name: PP.partner.name,
    type: PP.partner.type,
    city: PP.partner.city,
    email: PP.partner.email
  };

  /* Deelbare badge → klembord */
  var badgeBtn = document.getElementById('pp-badge-copy');
  if (badgeBtn) {
    badgeBtn.addEventListener('click', function(){
      var tmp = document.createElement('textarea');
      tmp.value = badgeBtn.getAttribute('data-embed');
      document.body.appendChild(tmp); tmp.select();
      try { document.execCommand('copy'); } catch(e){}
      document.body.removeChild(tmp);
      var ok = document.getElementById('pp-badge-copied');
      if (ok) { ok.classList.remove('hidden'); setTimeout(function(){ ok.classList.add('hidden'); }, 2500); }
    });
  }

  /* Klaviyo profielweergave */
  var _learnq = window._learnq || [];
  _learnq.push(['track', 'Partner Profiel Bekeken', { 'Partner Naam': ppData.name, 'Partner Type': ppData.type }]);

  /* Contactformulier → Klaviyo (lijst T9vBjg) + partner-notificatie */
  var form = document.getElementById('pp-contact-form');
  var submitBtn = document.getElementById('pp-submit-btn');
  var successMsg = document.getElementById('pp-form-success');
  if (!form) return;

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var naam = document.getElementById('pp-naam').value.trim();
    var email = document.getElementById('pp-email').value.trim();
    var telefoon = document.getElementById('pp-tel').value.trim();
    var interesse = document.getElementById('pp-interesse').value;
    var bericht = document.getElementById('pp-bericht').value.trim();
    if (!naam || !email || !interesse || !bericht) { var fe = form.querySelector(':invalid'); if (fe) fe.focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { document.getElementById('pp-email').focus(); return; }

    submitBtn.disabled = true; submitBtn.textContent = 'Bezig met versturen...';
    var labels = { koi_kopen:'Koi kopen', vijveradvies:'Vijveradvies', vijveraanleg:'Vijveraanleg', anders:'Anders' };
    var interesseLabel = labels[interesse] || interesse;

    var lq = window._learnq || [];
    lq.push(['identify', { '$email': email, '$first_name': naam, '$phone_number': telefoon || undefined, 'Interesse': interesseLabel, 'Laatste Partner Contact': ppData.name, 'Partner Type Interesse': ppData.type }]);
    lq.push(['track', 'Partner Profiel Contact', { 'Partner Naam': ppData.name, 'Partner Type': ppData.type, 'Partner Stad': ppData.city, 'Interesse': interesseLabel, 'Bericht': bericht, 'Bron': 'partner-profiel-v4' }]);

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SNdxLL', {
      method:'POST', headers:{'Content-Type':'application/json','revision':'2024-02-15'},
      body: JSON.stringify({ data:{ type:'subscription', attributes:{ custom_source:'Partner Contact - '+ppData.name, profile:{ data:{ type:'profile', attributes:{ email:email, first_name:naam, phone_number: telefoon || undefined, properties:{ partner_email: ppData.email, 'Interesse': interesseLabel, 'Laatste Partner Contact': ppData.name } } } } }, relationships:{ list:{ data:{ type:'list', id:'T9vBjg' } } } } })
    }).then(function(){
      try {
        fetch('https://hookdeck.vijvercentrum.nl/ueyg8dq8fdcylv', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ type:'lead', partner_email: ppData.email||'', partner_name: ppData.name||'', naam:naam, email:email, telefoon:telefoon||'', interesse:interesseLabel||'', bericht:bericht||'', bron:'Partner profiel: '+ppData.name }) });
      } catch(err){}
      form.classList.add('hidden');
      if (successMsg) successMsg.classList.remove('hidden');
    }).catch(function(){
      submitBtn.disabled=false; submitBtn.textContent='Verstuur aanvraag';
      if (formNote){ formNote.textContent='Er ging iets mis met versturen. Probeer opnieuw of app ons direct via WhatsApp.'; formNote.className='text-xs text-red-600 mt-3'; }
    });
  });
})();

  /* Partner- en klantcontext uit het JSON-eiland #pp-config hierboven.
     Zie ARCHITECTURE.md sectie 11. */
  var PP = { partner: { name: '', type: '', city: '', email: '', wa: '', tel: '' },
             klant: { ingelogd: false, email: '', naam: '', voornaam: '' } };
  try {
    var _ppEl = document.getElementById('pp-config');
    if (_ppEl) PP = Object.assign(PP, JSON.parse(_ppEl.textContent) || {});
  } catch (_e) {}

(function(){
  var D={ partner: PP.partner.name, type: PP.partner.type,
    wa: PP.partner.wa, email: PP.partner.email, tel: PP.partner.tel };
  var isCustomer = PP.klant.ingelogd;
  var _m=(window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.page)||{}; var loggedIn=isCustomer||!!_m.customerId;
  var modal=document.getElementById('pp-lead-modal'), form=document.getElementById('pp-lead-form'), btn=document.getElementById('pl-submit');
  if(!modal) return;
  var pendingChannel='whatsapp';
  function leadUrl(ch){ if(ch==='bel'){ return D.tel?('tel:'+D.tel):(D.wa?('https://wa.me/'+D.wa):('mailto:'+D.email)); } var m='Hoi '+D.partner+', ik heb een vraag via jullie Vijvercentrum-profiel.'; return D.wa?('https://wa.me/'+D.wa+'?text='+encodeURIComponent(m)):('mailto:'+D.email); }
  function go(url,ch){ if(ch==='bel'){ window.location.href=url; } else { window.open(url,'_blank'); } }
  function open(){ modal.classList.remove('hidden'); modal.classList.add('flex'); var n=document.getElementById('pl-naam'); if(n&&!n.value) n.focus(); }
  function close(){ modal.classList.add('hidden'); modal.classList.remove('flex'); }
  var custEmail=PP.klant.email, custName=PP.klant.naam;
  if(!custName) custName=PP.klant.voornaam;
  function directLead(naam,email){
    var lq=window._learnq||[];
    if(email){ lq.push(['identify',{ '$email':email, '$first_name':naam, 'Laatste Partner Contact':D.partner }]); }
    lq.push(['track','Partner Profiel Contact',{ 'Partner Naam':D.partner, 'Partner Type':D.type, 'Kanaal':pendingChannel, 'Ingelogd':true, 'Bron':'partner-profiel-v5-ingelogd' }]);
    try{ fetch('https://hookdeck.vijvercentrum.nl/ueyg8dq8fdcylv',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({type:'lead',partner_email:D.email||'',partner_name:D.partner,naam:naam,email:email,kanaal:pendingChannel,ingelogd:true,bron:'Partner profiel: '+D.partner})}); }catch(err){}
    var url = leadUrl(pendingChannel);
    setTimeout(function(){ go(url,pendingChannel); }, 150);
  }
  document.querySelectorAll('[data-partner-lead]').forEach(function(b){ b.addEventListener('click', function(){
    pendingChannel = b.getAttribute('data-partner-lead')||'whatsapp';
    if(loggedIn){ directLead(custName||(custEmail?custEmail.split('@')[0]:'Klant'), custEmail); return; } open(); }); });
  var lb=document.getElementById('pp-lightbox'), lbImg=document.getElementById('pp-lb-img');
  document.querySelectorAll('.pp-gallery-item').forEach(function(b){ b.addEventListener('click', function(){ if(lbImg) lbImg.src=b.getAttribute('data-img'); if(lb){ lb.classList.remove('hidden'); lb.classList.add('flex'); } }); });
  var lbc=document.getElementById('pp-lb-close'); if(lbc) lbc.addEventListener('click', function(){ lb.classList.add('hidden'); lb.classList.remove('flex'); });
  if(lb) lb.addEventListener('click', function(e){ if(e.target===lb){ lb.classList.add('hidden'); lb.classList.remove('flex'); } });
  document.getElementById('pp-lead-close').addEventListener('click', close);
  modal.addEventListener('click', function(e){ if(e.target===modal) close(); });
  form.addEventListener('submit', function(e){ e.preventDefault();
    var naam=document.getElementById('pl-naam').value.trim(), email=document.getElementById('pl-email').value.trim();
    if(!naam){document.getElementById('pl-naam').focus();return;} if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){document.getElementById('pl-email').focus();return;}
    btn.disabled=true;
    var lq=window._learnq||[];
    lq.push(['identify',{ '$email':email, '$first_name':naam, 'Laatste Partner Contact':D.partner }]);
    lq.push(['track','Partner Profiel Contact',{ 'Partner Naam':D.partner, 'Partner Type':D.type, 'Kanaal':pendingChannel, 'Ingelogd':isCustomer, 'Bron':'partner-profiel-v5-popup' }]);
    try{ fetch('https://hookdeck.vijvercentrum.nl/ueyg8dq8fdcylv',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({type:'lead',partner_email:D.email||'',partner_name:D.partner,naam:naam,email:email,kanaal:pendingChannel,ingelogd:isCustomer,bron:'Partner profiel: '+D.partner})}); }catch(err){}
    var url = leadUrl(pendingChannel);
    setTimeout(function(){ go(url,pendingChannel); close(); btn.disabled=false; }, 250);
  });
})();

(function(){
  var m=document.getElementById('pp-route-modal'); if(!m) return;
  function o(){ m.classList.remove('hidden'); m.classList.add('flex'); }
  function c(){ m.classList.add('hidden'); m.classList.remove('flex'); }
  document.querySelectorAll('[data-partner-route]').forEach(function(b){ b.addEventListener('click', o); });
  var x=document.getElementById('pp-route-close'); if(x) x.addEventListener('click', c);
  m.addEventListener('click', function(e){ if(e.target===m) c(); });
})();
